var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-background"},[_c('img',{staticClass:"hero-background__img",attrs:{"src":_vm.srcSetImages['1440'],"srcset":_vm.srcSet}})])}
var staticRenderFns = []

export { render, staticRenderFns }